module.exports = __webpack_public_path__ + "img/622.142e4bbe.jpg";